 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"default~components-accounts-accounts-module~components-admin-settings-admin-settings-module~componen~9afcf491":"default~components-accounts-accounts-module~components-admin-settings-admin-settings-module~componen~9afcf491","default~components-accounts-accounts-module~components-admin-settings-admin-settings-module~componen~11bc855b":"default~components-accounts-accounts-module~components-admin-settings-admin-settings-module~componen~11bc855b","common":"common","components-reports-reports-module":"components-reports-reports-module","default~components-accounts-accounts-module~components-approvals-approvals-module~components-manage-~aceb36cc":"default~components-accounts-accounts-module~components-approvals-approvals-module~components-manage-~aceb36cc","components-manage-stocks-manage-stocks-module":"components-manage-stocks-manage-stocks-module","components-manage-customers-manage-customers-module":"components-manage-customers-manage-customers-module","components-manage-transfers-manage-transfers-module":"components-manage-transfers-manage-transfers-module","default~components-accounts-accounts-module~components-manage-sales-manage-sales-module":"default~components-accounts-accounts-module~components-manage-sales-manage-sales-module","components-accounts-accounts-module":"components-accounts-accounts-module","default~components-manage-products-manage-products-module~components-stock-stock-module":"default~components-manage-products-manage-products-module~components-stock-stock-module","components-stock-stock-module":"components-stock-stock-module","default~components-admin-settings-admin-settings-module~components-authorization-authorization-modul~f126aee3":"default~components-admin-settings-admin-settings-module~components-authorization-authorization-modul~f126aee3","components-config-settings-config-settings-module":"components-config-settings-config-settings-module","components-admin-settings-admin-settings-module":"components-admin-settings-admin-settings-module","components-authorization-authorization-module":"components-authorization-authorization-module","components-approvals-approvals-module":"components-approvals-approvals-module","components-settings-settings-module":"components-settings-settings-module","hammerjs":"hammerjs","canvg":"canvg","dompurify":"dompurify","html2canvas":"html2canvas"}[chunkId]||chunkId) + "-es2015." + {"default~components-accounts-accounts-module~components-admin-settings-admin-settings-module~componen~9afcf491":"127dd3c9e6f374e2aa0f","default~components-accounts-accounts-module~components-admin-settings-admin-settings-module~componen~11bc855b":"711b674f42e96797c873","common":"084d8351e6907ce238f6","components-reports-reports-module":"d179090f782c7ad2d3ce","default~components-accounts-accounts-module~components-approvals-approvals-module~components-manage-~aceb36cc":"ea7473847a1c99dc348b","components-manage-stocks-manage-stocks-module":"2238f3d1cae72e717c9b","components-manage-customers-manage-customers-module":"5cda56693ae7b06ba9a1","components-manage-transfers-manage-transfers-module":"556ca7fe076439022a12","default~components-accounts-accounts-module~components-manage-sales-manage-sales-module":"6d48600fbcb21e07bde9","components-accounts-accounts-module":"dc0b670ada56b8fd6f3f","default~components-manage-products-manage-products-module~components-stock-stock-module":"07344c1a9c7b12c6b4d4","components-stock-stock-module":"0682355ffcc1bf1b4110","default~components-admin-settings-admin-settings-module~components-authorization-authorization-modul~f126aee3":"1cb333e5393fade68c13","components-config-settings-config-settings-module":"ee04552ffe70f40cda3e","components-admin-settings-admin-settings-module":"00f6f7dbe67ed7793c73","components-authorization-authorization-module":"0906f0329f2c4868eb02","components-approvals-approvals-module":"722831cd42a8e1bbf25c","components-settings-settings-module":"618afdae2efdd79bf2de","hammerjs":"2dc66a2697fa38e54db7","canvg":"d5da0e0a94e96aeac93c","dompurify":"18f42d18a4b3b28a624b","html2canvas":"2e1180939fcead8a7845"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
